import React from 'react';
import Image from 'gatsby-plugin-sanity-image';

export const ImageModule = ({ image, className }) => {
  return image && <Image {...image} className={`${className} w-full`} />;
};
